import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import configureStore, { history } from './redux/store'
import axios from 'axios'

import App from './containers/app'
import ResolveAuthentication from './components/Auth'

import config from './config'
import segment_io from './lib/segment-io'

import './index.css'

import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'

// for tooltips
import 'bootstrap/dist/js/bootstrap.bundle.min'

import Amplify, { Auth } from 'aws-amplify'
import { getCookieValue, deleteCookie } from './lib/cookies'
import SessionService from './lib/services/SessionService'

import {aws_config} from './aws_config'


// Setup AWS Amplify Auth and Storage with configuration
Amplify.configure(aws_config)


const { commit } = require('./version.json')
console.warn(`Running version ${commit}`)
segment_io(config.segmentIOKey)

axios.defaults.baseURL = config.apiUrl

var loc = window.location.href + ''
if (loc.indexOf('localhost') == -1 && loc.indexOf('http://') == 0) {
    window.location.href = loc.replace('http://', 'https://')
}

// calc hashcode from string
let hashCode = function (str: string) {
    var hash = 0,
        i,
        chr
    if (str.length === 0) return hash
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i)
        hash = (hash << 5) - hash + chr
        hash |= 0 // Convert to 32bit integer
    }
    return hash
}

// the same as "FnGenerateUUID"
const generateUUID = (str: string) => {
    let hh = hashCode('' + str)
    let id = ('' + hh).replace('-', 'M')
    return id
}


// add for every request a custom header to identify the call
axios.interceptors.request.use(
    function (config) {
        let partnerLogged = SessionService.getPartnerLogged();
        let userLogged = SessionService.getUsernameLogged();
        if (userLogged != '') {
            try {
                config.headers['requestId'] = generateUUID(
                    partnerLogged.partnerId + '' + userLogged + '' + new Date().getTime()
                )
            } catch (e) {
                //
            }
        }
        return config
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error)
    }
)


// refresh every 15 minutes: calling Auth.currentSession() will refresh session if we present a valid refresh token
setInterval(() => {
    console.log('SESSION_REFRESH_CALLBACK::refresh session interval' + new Date())
    //window.location.reload()

    Auth.currentSession()
        .then(session => console.log("cognito session refreshed ", session))
        .catch(err => console.log("cognito session refresh error: ", err))
        ;

}, 60000 * 45) // 45 minutes refresh - see aws forum for specific cognito refresh timings



const MAX_RETRIES = 2
let retriesMap: { [key: string]: number; } = {}

// Catch all 401 errors: try to refresh the access token calling Cognito refresh, then replay the api call that is failing
axios.interceptors.response.use(
    // notify user if a POST, PATCH, DELETE has completed successfully (HTTP 200 ok)
    response => {
        console.log('OK Response', response)

        // 504 - timeout - reset retries map if we got a success
        if (retriesMap.hasOwnProperty(response.config.url as string)) {
            retriesMap[response.config.url as string] = MAX_RETRIES
        }

        // handle OK response
        if (response && response.config && response.config.url && response.config.method === 'post' && response.config.url.indexOf('upload_notification') != -1) {
            Alert.success('Upload queued successfully!')
        } else if (
            response &&
            response.config &&
            response.config.method === 'post' &&
            response.config.url &&
            (response.config.url.indexOf('audiencelink') != -1 ||
                response.config.url.indexOf('audiencesync') != -1 ||
                response.config.url.indexOf('license') != -1 ||
                response.config.url.indexOf('/audience/bulk') != -1 ||
                response.config.url.indexOf('/license/bulk') != -1)
        ) {
            //Alert.success("Upload queued successfully!")
        } else if (response && response.config && response.config.method === 'post') {
            Alert.success('Creation successful!')
        } else if (response && response.config && (response.config.method === 'put' || response.config.method === 'patch')) {
            Alert.success('Update successful!')
        } else if (response && response.config && response.config.method === 'delete') {
            Alert.success('Delete successful!')
        }
        return response
    },
    error => {
        console.error('response error', error, error.config, error.response)

        if (error.response && error.response.status) {
            console.error('response error status ', error.response.status)
        }


        // 403 - invalid cookie. cognito auth error, cookie expired or bad cookie token
        if (error.config && error.response && error.response.status === 403) {    
            SessionService.logout()

            // then redirect to login page 
            window.location.href = '/signin';
            return;

        }

        // Cognito un-auth
        if (error.config && error.response && error.response.status === 401) {
            console.log('[401 retry] - catch error 401')

            let partnerMasqueradingSeller = SessionService.getPartnerMasqueradedSeller()
            // if cookie is expired, delete it 
            console.log('*** interceptor 401 bad cookie: Seller logout ')
            if (partnerMasqueradingSeller != null) {
                
                SessionService.logout()

                // then redirect to login page 
                window.location.href = '/signin';
                return
            }



            if (error.response.data && error.response.data.message) {
                console.log('[401 retry] - catch error 401', error.response.data.message)
            }

            // Reload only if cognito says that the token is expired
            if (error.response && error.response.data
                && (error.response.data.message === 'The incoming token has expired' || error.response.data.message === 'Unauthorized')) {

                // reload entire route
                window.location.reload()

               
            }
        }

        // if even after a refresh attempt we cannot use the old token, reoad page...
        if (error.config && error.response && error.response.status === 400) {
            console.log('[400 retry] - catch error 400')
            // Reload only if cognito says that the token is expired
            if (
                error.response &&
                error.response.data &&
                error.response.data.message &&
                error.response.data.message.indexOf('Refresh Token has expired') != -1
            ) {
                window.location.reload()
            }
        }

        // timeoud out (like when lambda cold starts or is stopped after some minutes)
        if (error.config && error.response && error.response.status === 504) {
            console.log('[504 retry] - catch error 504 timeouts api')
            // Reload only if cognito says that the token is expired
            //if( error.response && error.response.data && error.response.data.message === "Endpoint request timed out" ) {
            //window.location.reload()

            // REDOING CALL - init if not exists
            if (!retriesMap.hasOwnProperty(error.config.url as string)) {
                retriesMap[error.config.url] = MAX_RETRIES
            }
            console.log('[504 retry] - retry map ', error.config.url, retriesMap[error.config.url])

            retriesMap[error.config.url] = retriesMap[error.config.url] - 1
            if (retriesMap[error.config.url] > 0) {
                console.log('[504 retry] - retry map REDOING CALL ', error.config.url, retriesMap[error.config.url])

                // axios - redo the previous failed request
                return axios.request(error.config)
            }
            //}
        }

        if (error.config && ((error.response && error.response.status === 400) || (error.response && error.response.status === 500))) {
            Alert.error(error.response.data.messages[0])
        }

        return Promise.reject(error)
    }
)


let store = configureStore()
let rootComponent = render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div>
                <ResolveAuthentication />
                <App />

                <Alert stack={{ limit: 3 }} />
            </div>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
)
